import React from 'react';
import Slider from 'react-slick';
import ContentfulSection from 'components/Contentful/ContentfulSection';
import transformTemplateData from 'utils/transformTemplateData';
import getBreakpointView from 'utils/getBreakpointView';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import leftArrowDesktop from './images/left-arrow-desktop.svg';
import rightArrowDesktop from './images/right-arrow-desktop.svg';
import leftArrowMobile from './images/left-arrow-mobile.svg';
import rightArrowMobile from './images/right-arrow-mobile.svg';

import { Container } from './styles';

const ContentfulCarousel = ({ layouts }) => {
  const isMobile = getBreakpointView(['xs', 'sm']);

  const sliderSettings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: true,
    autoplay: false,
    draggable: true,
    swipeToSlide: true,
    speed: 500,
    nextArrow: (
      <div className="slider-next-arrow">
        <img src={isMobile ? rightArrowMobile : rightArrowDesktop} />
      </div>
    ),
    prevArrow: (
      <div className="slider-prev-arrow">
        <img src={isMobile ? leftArrowMobile : leftArrowDesktop} />
      </div>
    ),
  };
  const includesFullWidthBackground = layouts.some(layout => layout.template.fullWidthBackground);

  return (
    <Container includesFullWidthBackground={includesFullWidthBackground}>
      <Slider {...sliderSettings}>
        {layouts.map((layout, index) => {
          const item = transformTemplateData(layout);

          return <ContentfulSection {...item} />;
        })}
      </Slider>
    </Container>
  );
};

export default ContentfulCarousel;
